import React, { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import LoyaltyIcon from "@mui/icons-material/Loyalty";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useAddToFavMutation } from "api/menu";
import Swal from "sweetalert2";
import { IMAGE_URL } from "config";

export const MealHeader = ({ menu, id }) => {
  const [addToFav, { isLoading }] = useAddToFavMutation();
  const [iconClr, setIconClr] = useState("white");
  const profile = JSON.parse(localStorage.getItem("user"))
  console.log("profile", profile?.profile?._id)
  const favoriteMenu = () => {
    try {
      addToFav({ ...id, userId: profile?.profile?._id }).then((res) => {
        console.log("id", id);
        if (res.error) {
          console.log("error", res.error);
          Swal.fire("Failed!! , ");
        } else {
          console.log(res.data)
          Swal.fire("Success", res.data.message);
          setIconClr((prevIconClr) =>
            prevIconClr === "white"
              ? "red"
              : prevIconClr === "red"
                ? "white"
                : null
          );
        }
      });

      // iconClr==='white'?setIconClr('red'):iconClr==='red'?setIconClr('white'):null
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box>
      <Box
        // component={"container"}
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "block",
            lg: "block",
          },
          backgroundImage: `url(${IMAGE_URL + menu?.image})`,
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: {
            xl: "857.47px",
            lg: "557.47px",
            md: "410px",
            sm: "300px",
            xs: "200px",
          },
          backgroundSize: {
            lg: "cover",
            md: "cover",
            sm: "cover",
            xs: "cover",
          },
          borderRadius: "6px",
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "end",
              color: "#FFFFFF",
              width: "100%",
              height: {
                xl: "857.47px",
                lg: "557.47px",
                md: "410px",
                sm: "300px",
                xs: "200px",
              },
              borderRadius: "6px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                width: { lg: "100%", md: "100%", sm: "100%", xs: "100%" },
                justifyContent: "space-between",
                background:
                  "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%)",
                borderRadius: "6px",
                alignItems: "center",
              }}
            >
              <Box sx={{ paddingLeft: "16px", paddingTop: "6px" }}>
                <Box>
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "34px",
                        md: "34px",
                        sm: "20px",
                        xs: "13px",
                      },
                      fontWeight: 600,
                    }}
                  >
                    {menu?.name}
                    {/* Dish */}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "row" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "end",
                    }}
                  >
                    <Box>
                      <LoyaltyIcon
                        sx={{
                          fontSize: {
                            lg: "18px",
                            md: "18px",
                            sm: "16px",
                            xs: "12px",
                          },
                        }}
                      />
                    </Box>
                    <Box sx={{ ml: "10px" }}>
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "18px",
                            md: "18px",
                            sm: "16px",
                            xs: "10px",
                          },
                          fontWeight: "400",
                          paddingTop: "5px",
                        }}
                      >
                        Starting from $50 (Weekly)
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  paddingRight: "24px",
                  paddingTop: {
                    lg: "60px",
                    md: "60px",
                    sm: "50px",
                    xs: "40px",
                  },
                }}
              >
                <IconButton onClick={favoriteMenu}>
                  <FavoriteIcon
                    sx={{
                      width: {
                        lg: "24px",
                        md: "24px",
                        sm: "16px",
                        xs: "14px",
                      },
                      height: {
                        lg: "24px",
                        md: "24px",
                        sm: "16px",
                        xs: "14px",
                      },
                      color: `${iconClr}`,
                    }}
                  />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
